import { DivIcon } from "leaflet";

/**
 * Property marker as an SVG "pin" tinted with To2casa navy.
 */
export const propertyMarkerIcon = new DivIcon({
  className: "t2c-marker",
  html: `
    <div class="t2c-pin">
      <svg viewBox="0 0 32 44" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 0C7.2 0 0 7 0 15.6 0 27 16 44 16 44s16-17 16-28.4C32 7 24.8 0 16 0z" fill="#0B2545"/>
        <circle cx="16" cy="15" r="10" fill="#ffffff"/>
        <path d="M10 16.5L16 11l6 5.5v5c0 .3-.2.5-.5.5H19v-4h-6v4h-2.5c-.3 0-.5-.2-.5-.5v-5z" fill="#0B2545"/>
      </svg>
    </div>`,
  iconSize: [32, 44],
  iconAnchor: [16, 44],
  popupAnchor: [0, -40],
});

export const highlightMarkerIcon = new DivIcon({
  className: "t2c-marker t2c-marker-active",
  html: `
    <div class="t2c-pin t2c-pin-active">
      <svg viewBox="0 0 32 44" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 0C7.2 0 0 7 0 15.6 0 27 16 44 16 44s16-17 16-28.4C32 7 24.8 0 16 0z" fill="#134074"/>
        <circle cx="16" cy="15" r="10" fill="#ffffff"/>
        <path d="M10 16.5L16 11l6 5.5v5c0 .3-.2.5-.5.5H19v-4h-6v4h-2.5c-.3 0-.5-.2-.5-.5v-5z" fill="#134074"/>
      </svg>
    </div>`,
  iconSize: [40, 54],
  iconAnchor: [20, 54],
  popupAnchor: [0, -50],
});

/** Pulsing dot marker for the current user's location. */
export const userLocationIcon = new DivIcon({
  className: "t2c-user-marker",
  html: `
    <div class="t2c-user-dot">
      <span class="t2c-user-pulse"></span>
      <span class="t2c-user-core"></span>
    </div>`,
  iconSize: [22, 22],
  iconAnchor: [11, 11],
});
